import React from "react";
import PropTypes from "prop-types";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const theme = createTheme({
    typography: {
      h6: {
        fontFamily: "Texta-bold",
      },
      subtitle1: {
        fontFamily: ["Texta-book", "Helvetica", "Arial", "sans-serif"].join(','),
        fontSize: 20,
      },
    },
  });

const PartialSignupDetails = ({row}) => {

    const formatPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) {
          return '-';
        }
      
        const cleaned = ('' + phoneNumber).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
      
        return phoneNumber;
      };

    return (
    <Grid container className="collapsibleTable" spacing={2} paddingBottom={2}>
        <ThemeProvider theme={theme}>
            <Grid item xs={4}>
                <Typography variant="h6" gutterBottom component="div">
                    Client Full Name
                </Typography>
                <Typography variant="label" gutterBottom>
                    {row.clientNam ? row.clientNam : '-'}
                </Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant="h6" gutterBottom component="div">
                    Client Phone
                </Typography>
                <Typography variant="label" gutterBottom>
                    {row.phoneNumber ? formatPhoneNumber(row.phoneNumber) : '-'} 

                </Typography>
            </Grid>
            <Grid item xs={4} className="word-wrap">
                <Typography variant="h6" gutterBottom component="div">
                    Client Preferred Email
                </Typography>
                <Typography variant="label" gutterBottom>
                    {row.clientPreferdEmail ? row.clientPreferdEmail : '-'} 
                </Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant="h6" gutterBottom component="div">
                    Client Preferred Phone
                </Typography>
                <Typography variant="label" gutterBottom>
                    {row.clientPreferdPhone ? formatPhoneNumber(row.clientPreferdPhone) : '-'} 
                </Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant="h6" gutterBottom component="div">
                    Last Updated Time
                </Typography>
                <Typography variant="label" gutterBottom>
                    {row.lastUpdtTs ? row.lastUpdtTs : '-'}
                </Typography>
            </Grid>

        </ThemeProvider>
        </Grid>
    )
}

PartialSignupDetails.propTypes = {
    row: PropTypes.object.isRequired,
};

export default PartialSignupDetails;